module.exports = __webpack_public_path__ + "img/10_en.de6ea3f7.png";